import React from 'react';

const SvgKioskCreatedBy: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    viewBox="-3 -4 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.55932 15V11.4407M9.9322 13.8136V15M5.18644 15H12.3051M13.4915 10.2542C13.4915 10.9095 12.9603 11.4407 12.3051
      11.4407H5.18644C4.5312 11.4407 4 10.9095 4 10.2542V2.18644C4 1.5312 4.5312 1 5.18644 1H12.3051C12.9603 1 13.4915
      1.5312 13.4915 2.18644V10.2542Z"
      stroke="#292F37"
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgKioskCreatedBy;
